module.exports = __webpack_public_path__ + "static/media/SPTB.7ce41f14.pdf";